import { EVENTS } from '../utils/constants.js'
import makeLogin from '../applications/makeLogin.js'
import publishUserData from '../applications/publishUserData.js'

class OnLoginFormSubmitted {
  static register(context) {
    context.events.handle(EVENTS.LOGIN_FORM_SUBMITTED, async payload => {
      try {
        const loginRes = await makeLogin(context, payload)
        if (!loginRes.success) return
        await publishUserData(context)
        context.events.dispatch(EVENTS.USER_CONNECTED)
      } catch (error) {
        console.log('🚀 ~ OnLoginFormSubmitted ~ register ~ error:', error)
        context.sendBugAlert(error)
      }
    })
  }
}
export default OnLoginFormSubmitted
